"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentService = void 0;
const content_service_1 = require("./content-service");
const query_client_1 = require("../query-client");
exports.contentService = new content_service_1.ContentService({
    resource: 'content',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
